module.exports = __webpack_public_path__ + "static/img/report.62f4d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report.jpg
// module id = H238
// module chunks = 32